import {RootState} from 'src/store/rootReducer';

export const getItems = (state: RootState) => state.moderator.items;
export const getSorter = (state: RootState) => state.moderator.sorter;
